<ic-icon-button
  [cssClasses]="'actionIcons'"
  [ariaLabel]="titleIcon"
  [matIcon]="iconName"
  [matIconClass]="matIconClass"
  (icClick)="executeActionIcons()"
  [inline]="true"
>
</ic-icon-button>
